export default __webpack_public_path__ + "668146db92e30961fc527ab927e1780c.svg";